// src/lib/auth.js
import { push } from 'svelte-spa-router';

const SESSION_TIMEOUT = 1000 * 60 * 10;

export function requireLogin() {
  const savedUser = localStorage.getItem('loggedInUser');
  if (!savedUser) {
    push('/login');
    return null;
  }

  const parsed = JSON.parse(savedUser);
  if (Date.now() > parsed.expiresAt) {
    localStorage.removeItem('loggedInUser');
    push('/login');
    return null;
  }

  return parsed;
}

export function setupSessionWatcher() {
  function resetSessionTimeout() {
    const session = JSON.parse(localStorage.getItem('loggedInUser'));
    if (session) {
      session.expiresAt = Date.now() + SESSION_TIMEOUT;
      localStorage.setItem('loggedInUser', JSON.stringify(session));

      // ✅ 서버 세션도 연장
      fetch('/api/users/ping', {
        method: 'POST',
        credentials: 'include'
      }).catch((err) => {
        console.error('세션 연장 ping 실패:', err);
      });
    }
  }

  window.addEventListener('mousemove', resetSessionTimeout);
  window.addEventListener('keydown', resetSessionTimeout);
  window.addEventListener('click', resetSessionTimeout);

  const interval = setInterval(() => {
    const saved = localStorage.getItem('loggedInUser');
    if (saved) {
      const parsed = JSON.parse(saved);
      if (Date.now() > parsed.expiresAt) {
        localStorage.removeItem('loggedInUser');
        location.reload();
      }
    }
  }, 1000);

  return () => {
    clearInterval(interval);
    window.removeEventListener('mousemove', resetSessionTimeout);
    window.removeEventListener('keydown', resetSessionTimeout);
    window.removeEventListener('click', resetSessionTimeout);
  };
}